export const SIGNIN = 'SIGNIN'
export const TOKEN = 'TOKEN'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const CLEAR_TOKEN = 'CLEAR_TOKEN'
export const SET_UUID = 'SET_UUID'
export const GET_UUID = 'GET_UUID'
export const SET_APPEAL_PERMISSION = 'SET_APPEAL_PERMISSION'
